import React from 'react'
import DooraHelperModal from '../../landing/DooraHelperModal'

type MessageHelperModalProps = {
  isOpen: boolean
  onClose: () => void
}

const MessageHelperModal: React.FC<MessageHelperModalProps> = ({isOpen, onClose}) => {
  if (!isOpen) {
    return null
  }

  return <DooraHelperModal onClose={onClose} />
}

export default MessageHelperModal
